import { Component, OnInit, ElementRef, ViewChild, ViewChildren, Input, OnDestroy, EventEmitter, Output, OnChanges, ChangeDetectorRef, Renderer2 } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { environment } from '../../constants/env.constant';
import { Subscription } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { LibraryService } from '../../services/library.service';

declare let $;

@Component({
  selector: 'authentication-popup',
  templateUrl: './authentication-popup.component.html',
  styleUrls: ['./authentication-popup.component.less']
})
export class AuthenticationPopupComponent implements OnInit, OnChanges, OnDestroy {
  @Input() authData: any;
  @Input() additionalData: any = '';
  @Input() isOTPFailed: boolean = false;

  header: string;
  title: string;
  subTitle: string;
  authCode: any;

  isCodeInvalid: boolean = false;

  isOtpFailed: boolean = false;

  mobileNumber: string;

  expireMessage: "OTP code has expired.";

  @ViewChild('otp') elementRef: ElementRef;

  codeForm: FormGroup;
  formInput = ['input1', 'input2', 'input3', 'input4', 'input5', 'input6'];
  @ViewChildren('formRow') rows: any;

  counter: number = 0;
  interval: any = null;
  pinInfo: any;

  sessionTime: number = 5;

  isTimeOutHappened: boolean = false;

  Math: any;

  pollCounter: number = 0;
  requestId: any;
  pollingSubscription: Subscription;
  expired_message: string = 'Confirmation code has expired.';

  @Output() otpSent: EventEmitter<boolean> = new EventEmitter();
  @Output() codeVerified: EventEmitter<any> = new EventEmitter();
  @Output() popupClosed: EventEmitter<boolean> = new EventEmitter();
  @Output() hideSendAgain: EventEmitter<boolean> = new EventEmitter();
  mobileNo: any;
  isBackSpaceHold: boolean = false;
  constructor(
    private librayService: LibraryService,
    private renderer: Renderer2
  ) {
    this.Math = Math;
    this.codeForm = this.toFormGroup(this.formInput);
  }

  ngOnInit() { }

  ngOnChanges() {

    this.header = this.authData.header;
    this.title = this.authData.title;
    this.subTitle = this.authData.subTitle;
    this.authCode = this.authData.authCode;
    this.mobileNo = this.authData.mobileNo;

    if (this.authData.authType === 'SCA') {
      this.isTimeOutHappened = this.isOTPFailed;

      // Start auth code timeout
      this.startCountdown(
        //this.helperService.scaCodeTimeout,
        environment.MOB_AUTH_CODE_EXPIRY_TIMEOUT,
        "PAY_AUTH_CODE_VERIFY.PROCESS.AUTH_EXPIRED"
      );

      // Start polling
      setTimeout(() => {
        this.startPolling(environment.MOB_AUTH_CODE_EXPIRY_TIMEOUT);
      }, 2000);
    } else {
      this.codeForm.reset();

      this.sessionTime = this.authData.sessionTime;

      this.isOtpFailed = this.isOTPFailed;

      if(!this.isOtpFailed) {
        this.isTimeOutHappened = false;
      }

      if(this.isOtpFailed) {
        this.clearSession();
        this.hideSendAgain.emit(true);
        setTimeout(() => {
          const inputTel = this.renderer.selectRootElement('.input_5');
          inputTel.blur();
        }, 100);

        // $(".input_5").blur();
        return;
      }

      this.startCountdown(this.sessionTime);

      if(this.elementRef) {
        this.elementRef.nativeElement.focus();
      }

    }

  }

  ngAfterViewChecked() {

  }

  ngOnDestroy() {
    if (this.pollingSubscription) {
      this.pollingSubscription.unsubscribe();
    }
  }

  ngAfterViewInit() {
    if (!this.isOtpFailed) {
      this.elementRef.nativeElement.focus();
    }
  }

  /* This is the startCountdown function
   * @param seconds number
   * @returns void
   */
  startCountdown(seconds: any, expiryCode: string = 'PAYMENTS.PAYMENT.SMS_CODE_EXPIRED'): void {
    console.log(this.interval);
    if(this.interval){
      return
    }

    this.counter = 0;
    this.counter = seconds * 60;

    this.interval = setInterval(() => {
      this.counter--;
      this.expired_message = '';
      if (this.counter == 0) {
        this.clearSession();
        this.codeForm.reset();
        this.isTimeOutHappened = true;
        this.hideSendAgain.emit(true);
        this.expired_message = "Confirmation code has expired.";
        this.authCode = 'XXXX';
        this.isOtpFailed = false;
        if(this.authData.authType === 'OTP' ) {
          this.elementRef.nativeElement.blur();
        }

        if (this.pollingSubscription) {
          this.pollingSubscription.unsubscribe();
        }
      }
    }, 1000);
  }

  clearSession() {
    clearInterval(this.interval);
    this.counter = 0;
    this.interval = null;
    this.pollCounter = 0;
  }


  /* This is the startPolling function
  * @param No
  * @returns void
  */
  startPolling(sessionTime = null) {
    if (sessionTime) {
      this.pollCounter = sessionTime - 1;
    } else {
      this.pollCounter = this.pollCounter - 1;
    }
    this.pollingSubscription = this.librayService.pollPaymentAuthCodeStatus(
      this.authData.requestId, null, this.authData.cardId
    ).subscribe(
      (res: any) => {
        if (res === "PENDING") {
          setTimeout(() => {
            this.startPolling();
          }, environment.MOB_AUTH_CODE_POLLING_TIMEOUT);
        } else if (res === "AUTHORIZED") {
          this.codeVerified.emit(res);
        } else {

          this.clearSession();
          this.isTimeOutHappened = true;

          this.expired_message = 'Confirmation code has been denied.';
          this.authCode = 'XXXX';
        }
      },
      (error: HttpErrorResponse) => {
        if (error.status == 0) {
          setTimeout(() => {
            this.startPolling();
          }, environment.MOB_AUTH_CODE_POLLING_TIMEOUT);
        }
        else if (error.status == 404 || error.status == 504 || error.status == 410) {
          if (this.pollCounter > 0 && (error.status == 404 || error.status == 504)) {
            setTimeout(() => {
              this.startPolling();
            }, environment.MOB_AUTH_CODE_POLLING_TIMEOUT);
          } else {
            this.clearSession();
            this.requestId = null;
            this.expired_message = `Confirmation code has expired.`;
            this.authCode = 'XXXX';

            this.isTimeOutHappened = true;
          }
        }
        else if (error.error.errors) {
          if (error.error.errors[0].code == "DEVICE_AUTHORIZATION_FAILED") {
            this.clearSession();
            this.isTimeOutHappened = true;

            this.expired_message = `Confirmation code has been denied.`;
            this.authCode = 'XXXX';
            console.log(this.expired_message);
          }
        } else {
          this.clearSession();
          this.requestId = null;
          this.expired_message = this.librayService.getCodeText(
            "WENT_WRONG"
          );
          this.authCode = 'XXXX';

          this.isTimeOutHappened = true;

        }
      }
    );
  }

  /**
   * This is the checkValidUser function
   * @param No
   * @returns void
   */
  checkValidUser(): void | boolean {

    if (!this.codeForm.valid) {
      return this.makeFormDirty();
    }

    return true;
  }

  /**
  * This is the makeFormDirty function
  * @param No
  * @returns void
  */
  makeFormDirty(): boolean {
    let controls = <any>Object.keys(this.codeForm.controls).map(control => this.codeForm.controls[control]);
    controls.forEach(control => {
      // this.onFocusOut();
      control.markAsTouched();
      control.markAsDirty();
    });

    return false;
  }

  /**
   * This is the codeFailed function
   * @param response boolean
   * @returns boolean
   */
  codeFailed(response): boolean {
    this.codeForm.reset();
    return false;
  }

  /**
   * This is the resendCode function
   * @param No
   * @returns void
   */
  resendCode(): void {
    this.codeForm.reset();
    // this.isTimeOutHappened = false;
    // this.isOtpFailed = false;

    //this.isResendBtn = false;

    this.clearSession();

    this.otpSent.emit();
  }

  toFormGroup(elements) {
    const group: any = {};

    elements.forEach(key => {
      group[key] = new FormControl('', Validators.required);
    });
    return new FormGroup(group);
  }

  /**
  * Otp enter logic
  * @param event any
  *  @param index number
  *  @param eventType string
  * @returns void
 */
  onOTPEnter(event: any, index: number, eventType: string = "inputEvent") {

    if(this.isTimeOutHappened) return false;

    this.isBackSpaceHold = false;

    if (this.isOtpFailed == true) {
      return false;
      //this.isOtpFailed = false;
    }

    let pos = index;

    let code = event.target.value;

    if (event.repeat) {
      this.isBackSpaceHold = true;
    }

    if (code || (event.keyCode === 8 && event.which === 8) || (event.keyCode === 37 && event.which === 37) || (event.keyCode === 39 && event.which === 39)) {

      if ((event.keyCode === 8 && event.which === 8) || event.keyCode === 37 && event.which === 37) {
        pos = index - 1;
      } else {
        pos = index + 1;
      }

      if (pos > -1 && pos < this.formInput.length) {

        // On BackSpace, Left arrow, Right arrow
        if (eventType == 'keyUpEvent' && !this.isBackSpaceHold && (event.keyCode === 8 && event.which === 8) || (event.keyCode === 37 && event.which === 37) || (event.keyCode === 39 && event.which === 39)) {
          if (eventType != 'keydownEvent') {
            this.rows._results[pos].nativeElement.select();
          }
          // On Backspace hold
        } else if (this.isBackSpaceHold) {
          this.rows._results[pos].nativeElement.focus();
          // On enter value
        } else if (eventType == 'inputEvent') {
          this.rows._results[pos].nativeElement.focus();
        }
      }

      if (this.codeForm.valid && eventType == 'inputEvent') {
        this.isOtpFailed = false;
        this.isTimeOutHappened = false;
        let otpValue = this.codeForm.value;
        let pin = otpValue.input1 + otpValue.input2 + otpValue.input3 + otpValue.input4 + otpValue.input5 + otpValue.input6;

        // this.rows._results[pos].nativeElement.blur();
        this.elementRef.nativeElement.blur();
        this.codeVerified.emit(pin);
        return false;
      }
    }

  }

  /* Marks all controls in a form group as touched
* @param formGroup - The form group to touch
*/
  markFormGroupTouched(formGroup: FormGroup) {
    (<any>Object).values(formGroup.controls).forEach(control => {
      control.markAsTouched();

      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }

  /* function closePopup
* @param No
*/
  closePopup() {
    this.clearSession();
    this.popupClosed.emit(true);
  }

}
